import { servicesQuery } from '@/services/api';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL } from '../constants';

export function useEnvHealthObjects(
  workspaceId: number,
  simulate: ServicesApiGetEnvHealthQueryParams['simulate'],
  enabled = true,
) {
  return servicesQuery.getEnvHealthObjects.useQuery({
    queryKey: ['env-health-objects', workspaceId, simulate],
    queryData: { params: { environment_id: workspaceId }, query: { simulate } },
    refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL,
    enabled: workspaceId > 0 && enabled,
  });
}
